// Устаревшие экшены
import React, { useCallback } from 'react';
import { EventBus } from '@vtblife/event-bus';
import isEmpty from 'lodash/isEmpty';
import { useAnalytics } from '../hooks/use-analytics';
import { BlockKitContext } from './../contexts/context';
import { SCROLL_BLOCK_HASH_PREFIX, usePublishScrollEvent } from './events';
// Возвращает правильный экшн, в зависимости от авторизованности пользователя и прав (опционально)
export function useGetCorrectAction(action) {
  var _a, _b, _c;
  var context = React.useContext(BlockKitContext);
  if (((_a = context === null || context === void 0 ? void 0 : context.appContext) === null || _a === void 0 ? void 0 : _a.authInfo.isAuthenticated) && (action === null || action === void 0 ? void 0 : action.isActiveAuthorizedAction)) {
    var permissions = (_c = (_b = context.appContext) === null || _b === void 0 ? void 0 : _b.authInfo.user) === null || _c === void 0 ? void 0 : _c.permissions;
    if (isContextualActionScopedProps(action) && permissions && permissions.length > 0 && action.scopes && action.scopes.length > 0) {
      var match = action.scopes.every(function (s) {
        return permissions.includes(s);
      });
      if (match) {
        return action === null || action === void 0 ? void 0 : action.actionEntityAuthorized;
      } else {
        return action === null || action === void 0 ? void 0 : action.actionEntity;
      }
    }
    return action === null || action === void 0 ? void 0 : action.actionEntityAuthorized;
  } else {
    return action === null || action === void 0 ? void 0 : action.actionEntity;
  }
}
/**
 * В админке кнопки редактируются на трех этапах:
 * Контент, когда кнопкам задается текст
 * Дизайн, когда кнопкам задаются цвета
 * События, когда у кнопок определяется действие
 * Кнопка должна быть видна в админке, начиная с первого этапа
 */
export function isActionButtonVisible(action) {
  return Boolean(action && !isEmpty(action.text));
}
export function isContextualActionButtonVisible(action) {
  return isActionButtonVisible(action === null || action === void 0 ? void 0 : action.actionEntity) || (action === null || action === void 0 ? void 0 : action.isActiveAuthorizedAction) && isActionButtonVisible(action === null || action === void 0 ? void 0 : action.actionEntityAuthorized);
}
// Проверяет объект типа ContextualActionProps на содержание в нем действий (ActionProps)
export function hasActions(action) {
  return Boolean((action === null || action === void 0 ? void 0 : action.actionEntity) && Object.keys(action.actionEntity).length || (action === null || action === void 0 ? void 0 : action.actionEntityAuthorized) && Object.keys(action.actionEntityAuthorized).length);
}
// возвращает action нового формата на основе action'ов старого формата. функция необходима исключительно для старых блоков.
export function getNewAction(unauthorizedAction, authorizedAction) {
  return {
    actionEntity: unauthorizedAction,
    actionEntityAuthorized: authorizedAction,
    isActiveAuthorizedAction: authorizedAction && (authorizedAction === null || authorizedAction === void 0 ? void 0 : authorizedAction.text) !== '' && (authorizedAction === null || authorizedAction === void 0 ? void 0 : authorizedAction.action) !== ''
  };
}
function isContextualActionScopedProps(v) {
  var obj = v;
  return Array.isArray(obj['scopes']);
}
function usePublishBlockEvent(data) {
  var eventBus = EventBus.getInstance();
  return useCallback(function (href, event) {
    var createEvent = function createEvent(href, event) {
      if (event) return event;
      if (isHref(href)) {
        console.warn("Cannot create an event from eventType = ".concat(href, " ."));
        return undefined;
      }
      return {
        type: "BlockEvent:".concat(href.replace(/^event:/, '').trim()),
        data: data,
        category: 'simple'
      };
    };
    var toPublishing = createEvent(href, event);
    if (!toPublishing) {
      console.warn("An event won't be published. See the reason in messages before.");
      return;
    }
    eventBus.publish(toPublishing);
  }, [data, eventBus]);
}
export var vacanciesRegionEvent = 'blockEvent:changeVacanciesRegion';
export function useChangeVacanciesRegionEvent() {
  var eventBus = EventBus.getInstance();
  return useCallback(function (data) {
    eventBus.publish({
      type: vacanciesRegionEvent,
      data: data,
      category: 'simple'
    });
  }, [eventBus]);
}
export function isHref(href) {
  return href.startsWith('/') || href.startsWith('http') || href.startsWith(SCROLL_BLOCK_HASH_PREFIX);
}
export function useButtonHandles(action, data) {
  var _a, _b;
  var sendAnalytics = useAnalytics();
  var publishBlockEvent = usePublishBlockEvent(data);
  var publishScrollEvent = usePublishScrollEvent();
  if (action) {
    var href = ((_a = action.action) === null || _a === void 0 ? void 0 : _a.trim()) || '';
    var analyticsId = (_b = action.analyticsId) === null || _b === void 0 ? void 0 : _b.trim();
    var isAction = href || action.eventType;
    var handleClick = isAction ? function (e) {
      if (href.startsWith(SCROLL_BLOCK_HASH_PREFIX)) {
        var containerId = href.substr(SCROLL_BLOCK_HASH_PREFIX.length);
        e.preventDefault();
        var payload = parseEventPayload(action.eventData);
        publishScrollEvent({
          containerId: containerId,
          payload: payload
        });
      }
      publishBlockEvent(href, action ? createEvent(action.eventType, action.eventData) : undefined);
      if (analyticsId) {
        sendAnalytics(analyticsId);
      }
    } : undefined;
    return {
      href: href,
      handleClick: handleClick,
      dataTest: action === null || action === void 0 ? void 0 : action.dataTest
    };
  }
  return {
    href: ''
  };
}
function parseEventPayload(data) {
  if (!data) {
    return;
  }
  var showError = function showError() {
    return console.warn("Cannot parse: ".concat(data, ". Please specify an event data as a correct JSON object.\n         For example, the value could be: '{\"flow\":\"authorization\"}'"));
  };
  var payload = undefined;
  try {
    payload = JSON.parse(data);
  } catch (e) {
    showError();
    return;
  }
  if (typeof payload !== 'object') {
    showError();
    return;
  }
  return payload;
}
function createEvent(type, dataSerialized) {
  if (!type) {
    return;
  }
  var payload = parseEventPayload(dataSerialized);
  return {
    type: type,
    category: 'simple',
    data: payload
  };
}